import React, { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Likes from "../likes";
import Auctions_dropdown from "../dropdown/Auctions_dropdown";
import { useDispatch, useSelector } from "react-redux";
import { buyModalShow } from "../../redux/marketplaceSlice";
import {
  listHandle,
  unlistHandle,
  updatePriceHandle,
  buyHandle,
  buyPalletHandle,
  approveHandle,
} from "../../api/index";
import { useSigningCosmWasmClient, useWallet } from "@sei-js/react";
import { toast } from "react-toastify";
import { COLLECTIONS, DECIMAL } from "../../config";
import {
  createListing,
  updateListing,
  deleteListing,
  buy,
} from "../../utils/api";
import { updateCart } from "../../redux/marketplaceSlice";

const CategoryItemDetaiListView = ({ item, listing, signingClient }) => {
  /* eslint-disable */
  // const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState("");
  const [mode, setMode] = useState("Listing"); // Listing, UnListing, Buy
  const [listingId, setListingId] = useState();
  const [detailUrl, setDetailUrl] = useState("");

  const { cart, seiWallet } = useSelector((state) => state.marketplace);

  const listAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!price || Number(price) <= 0) {
      return toast.warning("Please input the price", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    setLoading(true);

    let id = toast.loading("Listing...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    const res = await listHandle(signingClient, seiWallet, {
      ...data,
      price: price * DECIMAL,
    });

    console.log("res: ", res);
    if (res.success) {
      toast.update(id, {
        render: "Listed successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
      await createListing({ ...data, price, address: seiWallet });
      setMode("UnListing");
    } else {
      toast.update(id, {
        render: "Listing Failed",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (item.marketplace == "pallet") {
      setDetailUrl(`/item/${item.collection_key}/${token_id}?external=true`)
    }
    else {
      setDetailUrl(`/item/${collection ? collection : contract}/${token_id}?external=false`)
    }
  }, [])

  useEffect(() => {
    // console.log("listing: ", listing);
    // console.log("item: ", item);
    if (item?.filter == true) setMode("Buy");
    for (let i = 0; i < listing.length; i++) {
      if (
        item?.token_id == listing[i].token_id &&
        listing[i].seller == seiWallet
      ) {
        setPrice((listing[i].price / DECIMAL).toFixed(3));
        setListingId(listing[i].id);
        setMode("UnListing");
      } else if (
        item?.token_id == listing[i].token_id &&
        listing[i].seller != seiWallet
      ) {
        setListingId(listing[i].id);
        setMode("Buy");
      } else {
        // setMode("Buy");
        // setListingId(listing[i].id);
      }
    }
  }, [item, listing]);

  const unListAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    setLoading(true);

    let id = toast.loading("Unlisting...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
    console.log(data);

    const res = await unlistHandle(signingClient, seiWallet, data);
    if (res.success) {
      await deleteListing({
        ...data,
        price,
        address: seiWallet,
        price: price * DECIMAL,
        listing_id: listingId,
      });
      setMode("Listing");
      setPrice("");
      toast.update(id, {
        render: "Unlisted successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "Unlisting Failed",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const updatePriceAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!price || Number(price) <= 0) {
      return toast.warning("Please input the price", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    setLoading(true);

    let id = toast.loading("updatePricing...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    const res = await updatePriceHandle(signingClient, seiWallet, {
      ...data,
      price: price * DECIMAL,
    });
    if (res.success) {
      await updateListing({
        ...data,
        price,
        address: seiWallet,
        price: price * DECIMAL,
        listing_id: listingId,
      });
      toast.update(id, {
        render: "UpdatePrice successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "UpdatePrice Failed",
        type: "error",
        autoClose: 2000,
        isLoading: false,
      });
    }
    setLoading(false);
  };

  const buyAction = async (data) => {
    if (loading) {
      return toast.warning("Can't click twice", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }

    setLoading(true);

    let id = toast.loading("Buying...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    console.log("buy: ", data);

    if (data?.marketplace == "pallet") {
      const res = await buyPalletHandle(signingClient, seiWallet, data);
      if (res.success) {
        toast.update(id, {
          render: "Bought successfully",
          type: "success",
          autoClose: 2000,
          isLoading: false,
        });
      } else {
        toast.update(id, {
          render: "Buy Failed",
          type: "error",
          autoClose: 2000,
          isLoading: false,
        });
      }
    } else {
      const res = await buyHandle(signingClient, seiWallet, data);
      if (res.success) {
        await buy({ ...data, address: seiWallet });
        setMode("Listing");
        toast.update(id, {
          render: "Bought successfully",
          type: "success",
          autoClose: 2000,
          isLoading: false,
        });
      } else {
        toast.update(id, {
          render: "Buy Failed",
          type: "error",
          autoClose: 2000,
          isLoading: false,
        });
      }
    }

    setLoading(false);
  };

  const addToCartAction = () => {
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    let flag = 1;
    for (let i = 0; i < cart.length; i++) {
      if (cart[i].id == item.id) flag = 0;
    }
    if (flag == 0) {
      return toast.warning("Already added", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    } else {
      toast.success("Successfully added", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    const temp = [...cart];
    temp.push({ ...item, address: seiWallet });
    dispatch(updateCart({ cart: temp }));
  };

  const {
    id,
    token_id,
    image,
    title,
    bidLimit,
    bidCount,
    contract,
    likes,
    creator,
    owner,
    collection,
  } = item;

  // console.log(`contract: ${collection}, token id ${token_id}`);

  return (
    <>
      {/* // Single list view start */}
      <Link
        href={detailUrl}
        key={id}
      >
        <a className="flex transition-shadow hover:shadow-lg" role="row">
          <div
            className="dark:border-jacarta-600 border-jacarta-100 flex w-[28%] items-center border-t py-4 px-4"
            role="cell"
          >
            {/* <span className="mr-2 lg:mr-4">{id}</span> */}
            <figure className="relative mr-2 w-8 shrink-0 self-start lg:mr-5 lg:w-12">
              <img
                src={image}
                alt={title}
                height={32}
                width={32}
                layout="responsive"
                objectFit="contain"
                className="rounded-2lg"
                loading="lazy"
              />

              {/* {icon && (
                            <div
                              className="dark:border-jacarta-600 bg-green absolute -right-2 -bottom-1 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white"
                              data-tippy-content="Verified Collection"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                className="h-[.875rem] w-[.875rem] fill-white"
                              >
                                <path fill="none" d="M0 0h24v24H0z"></path>
                                <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                              </svg>
                            </div>
                          )} */}
            </figure>
            <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
              {title}
            </span>
          </div>
          <div
            className="dark:border-jacarta-600 border-jacarta-100 flex w-[14%] items-center whitespace-nowrap border-t py-4 px-4"
            role="cell"
          >
            <span className="-ml-1" data-tippy-content="SEI">
              <svg className="icon mr-1 h-4 w-4">
                <use xlinkHref="/icons.svg#icon-SEI"></use>
              </svg>
            </span>
            <span className="text-sm font-medium tracking-tight">
              {mode == "Buy"
                ? item?.price
                  ? (item?.price / DECIMAL).toFixed(3)
                  : null
                : null}
            </span>
          </div>
          <div
            className="dark:border-jacarta-600 border-jacarta-100 flex w-[14%] items-center border-t py-4 px-4"
            role="cell"
          >
            {"-"}
          </div>
          <div
            className="dark:border-jacarta-600 border-jacarta-100 flex w-[14%] items-center border-t py-4 px-4"
            role="cell"
          >
            {owner?.slice(0, 4)}...{owner?.slice(-3)}
          </div>
          <div
            className="dark:border-jacarta-600 border-jacarta-100 flex w-[18%] items-center border-t py-4 px-4"
            role="cell"
          >
            <span className="-ml-1" data-tippy-content="SEI">
              <svg className="icon mr-1 h-4 w-4">
                <use xlinkHref="/icons.svg#icon-SEI"></use>
              </svg>
            </span>
            {item?.price && <span className="text-sm font-medium tracking-tight">
              <button
                type="button"
                className="bg-accent shadow-accent-volume flex justify-center items-center hover:bg-accent-dark w-30 rounded-full py-2 px-14 text-center font-semibold text-white transition-all"
              >
                Buy Now
              </button>
            </span>}
          </div>
          <div
            className="dark:border-jacarta-600 border-jacarta-100 flex w-[12%] items-center border-t py-4 px-4"
            role="cell"
          >
            {item?.price && <span>
              <Image
                src="/cart_icon.png"
                alt="cart"
                width={26}
                height={26}
                onClick={
                  () => addToCartAction(item)
                  // dispatch(buyModalShow())
                }
              />
            </span>}
          </div>
        </a>
      </Link>
      {/* // Single list view and */}
    </>
  );
};

export default CategoryItemDetaiListView;
